import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { Checkbox, FormControlLabel, TextField } from "@material-ui/core";
import CircleCheckedFilled from "@material-ui/icons/CheckCircle";
import CircleUnchecked from "@material-ui/icons/RadioButtonUnchecked";
import ControlledSelect from "./controlledSelect";
import MultiControlledTemplateSelect from "./multiControlledTemplateSelect";

export default function CreateTemplateConditionLineDialog({
    open,
    handleClose,
    data,
    onChange,
    onFormNameChange,
    onChecked,
    handleFormSubmit,
    templateConditionLineOption,
    templateFormNameOption,
}) {
    return (
        <div>
            <Dialog
                open={open}
                onClose={handleClose}
                maxWidth="xs"
                PaperProps={{ style: { width: "600px" } }}
            >
                <DialogTitle id="alert-dialog-title">
                    Create Template Condition Line
                </DialogTitle>
                <DialogContent>
                    <form onSubmit={handleFormSubmit}>
                        <TextField
                            type="text"
                            id="formId"
                            value={data.formId.value}
                            onChange={(e) => onChange(e)}
                            label="Form Id"
                            variant="outlined"
                            margin="dense"
                            disabled={true}
                            fullWidth
                        />
                        <ControlledSelect
                            id="formName"
                            label="Select Form Name"
                            value=""
                            options={templateFormNameOption}
                            onChange={onFormNameChange}
                            hasError={data.formName.hasError}
                            includeAllFlag="false"
                            isRequired={true}
                        />
                        <MultiControlledTemplateSelect
                            id="RegistrationState"
                            label="Select Registration State"
                            options={templateConditionLineOption?.registrationStates}
                            onChange={onChange}
                            includeAllFlag="true"
                            isRequired={true}
                        />
                        <MultiControlledTemplateSelect
                            id="TransactionType"
                            label="Select Transaction Type"
                            options={
                                templateConditionLineOption?.transactionType
                            }
                            onChange={onChange}
                            isRequired={true}
                        />
                        <MultiControlledTemplateSelect
                            id="PurchaseType"
                            label="Select Purchase Type"
                            options={templateConditionLineOption?.purchaseType}
                            onChange={onChange}
                            isRequired={true}
                        />
                        <MultiControlledTemplateSelect
                            id="CoBuyer"
                            label="Select CoBuyer"
                            options={templateConditionLineOption?.coBuyer}
                            onChange={onChange}
                            isRequired={true}
                        />
                        <MultiControlledTemplateSelect
                            id="InstallFrontPlate"
                            label="Select InstallFrontPlate"
                            options={
                                templateConditionLineOption?.installFrontPlate
                            }
                            onChange={onChange}
                            isRequired={true}
                        />
                        <MultiControlledTemplateSelect
                            id="TitleStatus"
                            label="Select Title Status"
                            options={
                                templateConditionLineOption?.titleStatus
                            }
                            onChange={onChange}
                            isRequired={true}
                        />
                        <MultiControlledTemplateSelect
                            id="VehicleModel"
                            label="Select Vehicle Model"
                            options={
                                templateConditionLineOption?.vehicleModel
                            }
                            onChange={onChange}
                            isRequired={true}
                        />
                        <MultiControlledTemplateSelect
                            id="Warranty"
                            label="Select Model Year"
                            options={templateConditionLineOption?.modelYear}
                            onChange={onChange}
                            isRequired={false}
                        />
                        <MultiControlledTemplateSelect
                            id="DeliveryState"
                            label="Select Delivery State"
                            options={
                                templateConditionLineOption?.deliveryStates
                            }
                            onChange={onChange}
                            isRequired={false}
                        />
                        <MultiControlledTemplateSelect
                            id="SpecialApplicabilityCondition"
                            label="Select Special Applicability Conditions"
                            options={
                                templateConditionLineOption?.specialApplicabilityConditions
                            }
                            onChange={onChange}
                            isRequired={false}
                        />
                        <FormControlLabel
                            control={
                                <Checkbox
                                    onChange={(e) => onChecked(e)}
                                    id="isActive"
                                    value={data.isActive.value}
                                    checked={data.isActive.value}
                                    icon={<CircleUnchecked />}
                                    checkedIcon={<CircleCheckedFilled />}
                                />
                            }
                            label="Is Active"
                        />
                        <DialogActions>
                            <Button
                                onClick={handleClose}
                                color="secondary"
                                variant="outlined"
                            >
                                Cancel
                            </Button>
                            <Button
                                type="submit"
                                color="primary"
                                variant="contained"
                            >
                                Submit
                            </Button>
                        </DialogActions>
                    </form>
                </DialogContent>
            </Dialog>
        </div>
    );
}
